/* document/index */ function _(require, module, exports) {
    var tslib_1 = require(426) /* tslib */;
    tslib_1.__exportStar(require(52) /* ./document */, exports);
    tslib_1.__exportStar(require(53) /* ./events */, exports);
}
